<div class="Customers overview-loyalty ui-g">

    <div class="ui-g-12 ui-lg-6">
        <h1 class="step-title">{{ translations.title }}</h1>
    </div>
    <div class="ui-g-12 ui-lg-12">
        <p-steps [model]="items" [(activeIndex)]="activeIndex" [readonly]="false"></p-steps>

        <kv-search-toolbar
                [date_structure]="searchModel.date_structure"
                [card_modes]="searchModel.card_modes"
                [clusters]="searchModel.cluster_list"
                [customersBoxEnabled]="false"
                [clusterFieldEnabled]="false"
                [dateBoxEnabled]="false"
                [group_types]="searchModel.group_types"
                [groups]="searchModel.groups"
                [areas]="searchModel.areas"
                [stores]="searchModel.stores"
                [disableMutualExclusivity]="false"
                [storeSelectionMode]="'multiple'"
                appQFilter
                (onQFilter)="ApplyResult($event)"
        ></kv-search-toolbar>

        <div class="overview-container card ui-g-nopad">
            <app-contactable-main-kpi [hidden]="activeIndex !== 0" ></app-contactable-main-kpi>
            <app-contactable-channel [hidden]="activeIndex !== 1" ></app-contactable-channel>
            <app-contactable-consent [hidden]="activeIndex !== 2" ></app-contactable-consent>
        </div>

    </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers-contactable/customers-contactable.component.html